import * as React from "react";
import { actionCreators } from "page/calendar/store";
import { CalendarState, BorderOptions } from "burde";
import { Option } from "appz";
import { getBorderOptions } from "ui/service";
import { actionCreators as burdeContentActionCreators } from "burde-api-content/store";
import BorderGallery from "../border-image-picker/index";

type CalendarFramePickerProps = {
    calendar: CalendarState;
    borderOptions: BorderOptions;
} & typeof actionCreators &
    typeof burdeContentActionCreators;

interface CalendarFramPickerState {
    frameOptions: Array<Option<string>>;
}

class CalendarFramePicker extends React.Component<
    CalendarFramePickerProps,
    CalendarFramPickerState
> {
    async componentDidMount() {
        const { calendar, borderOptions } = this.props;
        if (!borderOptions && calendar.culture) {
            const result = await getBorderOptions(
                calendar.culture,
                calendar.calendarSize,
            );
            if (result) {
                this.props.updateBorderOptions(result);
            }
        }
    }

    render() {
        return <BorderGallery />;
    }
}

export default CalendarFramePicker;
